import { render, staticRenderFns } from "./CourierPlan.vue?vue&type=template&id=7e7f643a&scoped=true&"
import script from "./CourierPlan.vue?vue&type=script&lang=js&"
export * from "./CourierPlan.vue?vue&type=script&lang=js&"
import style0 from "./CourierPlan.vue?vue&type=style&index=0&id=7e7f643a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7f643a",
  null
  
)

export default component.exports